<template>
	<div class="login-page h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
		<div
			:class="{
				'vx-col sm:w-4/5 md:w-3/4 lg:w-3/4 xl:w-3/5': !$store.getters.isClientUrl,
				'vx-col sm:w-4/5 md:w-3/4 lg:w-2/4 xl:w-2/5 max-w-md': $store.getters.isClientUrl,
			 }"
			class="sm:m-0 m-4"
		>
			<vx-card>
				<div slot="no-body" class="full-page-bg-color">

					<div class="vx-row no-gutter justify-center items-center">

						<img
							v-if="!$store.getters.isClientUrl"
							src="@/assets/images/pages/login.png"
							alt="login"
							class="mx-auto hidden lg:block"
						>

						<div
							:class="{ 'lg:w-1/2': !$store.getters.isClientUrl }"
							class="vx-col sm:w-full md:w-full d-theme-dark-bg"
						>
							<div class="px-8 pt-8 login-tabs-container">

								<div class="vx-card__title mb-4">
									<h4 class="mb-4"><b>{{ $t('entrance') }}</b></h4>
									<p>{{ $t('welcomeBack') }}! {{ $t('pleaseLoginToYourAccount') }}</p>
								</div>

								<div class="w-full">
									<vs-input
										label="E-Mail"
										name="email"
										v-validate="'required|email|min:3'"
										class="w-full"
										v-model="email"
										@input="handleEmail"
									/>

									<span v-if="errors.first('email')" class="text-danger text-sm">
										{{ $t('fieldFilledIncorrect') }}
									</span>
								</div>

								<div class="w-full">
									<vs-input
										:label="$t('password')"
										data-vv-validate-on="blur"
										v-validate="'required|min:6|max:32'"
										type="password"
										name="password"
										class="w-full mt-5"
										v-model="password"
										@input="handleInput"
									/>

									<span v-if="errors.first('password')" class="text-danger text-sm">
										{{ $t('fieldFilledIncorrect') }}
									</span>
								</div>

								<div class="flex flex-wrap justify-end my-5 mb-5">
									<router-link to="/reset">{{ $t('passwordRecovery') }}</router-link>
								</div>
								<div class="flex flex-wrap justify-between mb-3 my-10">
									<vs-button :disabled="!validateForm" @click="login">{{ $t('entrance') }}</vs-button>

									<router-link to="/register" v-if="$store.getters.isClientUrl">
										<vs-button type="border">
											{{ $t('registration') }}
										</vs-button>
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>


<script>
import notifier from "@/mixins/notifier";

export default {
	mixins: [notifier],
	data() {
		return {
			email: '',
			password: '',
		}
	},
	computed: {
		validateForm() {
			return !this.errors.any() && this.email !== '' && this.password !== '';
		},
	},
	mounted() {
		this.$validator.pause();
	},
	methods: {
		handleEmail() {
			this.email = this.email.trim()
			this.handleInput()
		},
		handleInput() {
			this.$validator.reset();
			this.$validator.pause();
		},
		async checkLogin() {
			this.$validator.resume();
			const isValidated = await this.$validator.validateAll()

			if(!isValidated) return false;

			// If user is already logged in notify
			if (this.$store.getters.isLoggedIn) {

				// Close animation if passed as payload
				// this.$vs.loading.close()

				this.notifyError(this.$t('youAreAlreadyLoggedIn'));
				return false;
			}

			return true;
		},
		async login() {
			if (!(await this.checkLogin())) return;

			// Loading
			this.$vs.loading()

			var payload = new FormData();

			payload.append('email', this.email);
			payload.append('password', this.password);

			let route = '';
			if(this.$store.getters.isClientUrl) {
				route = "/client/auth/login";
				const currentHostname = this.$store.state.website.currentHostname;
				payload.append('domain', currentHostname);

			} else {
				route = "/auth/login";
			}

			this.$store.dispatch('login', {payload,route})
				.then(() => {
					this.$vs.loading.close()
					this.$router.push('/');
				})
				.catch(error => {
					this.$vs.loading.close()
					this.$vs.notify({
						title: 'Error',
						text: error.message,
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'danger'
					})
				})
		},
	},
}
</script>

<style lang="scss">
.login-tabs-container {
	min-height: 400px;
	color: #626262;

	.con-tab {
		padding-bottom: 14px;
	}

	.con-slot-tabs {
		margin-top: 1rem;
	}
}

.login-page {
	&__logo {
		max-width: 90%;
		max-height: 90%;
	}
}
</style>
